import React, { FC } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export const snackbarMessage = 'The season is closed for now, you can register your interest below...'

const OffSeasonMessage: FC<React.PropsWithChildren<unknown>> = ({
  
}) => {
  return (
    <Box>
      <Typography gutterBottom>
        We Expect to be taking bookings for surveys from late October 2024, as soon as the outside temperature drops. Please register your interest below.
      </Typography>
      <Typography gutterBottom>
        We are very pleased to report that Retrofit West CIC are now offering vouchers paying <strong>70% of the cost of your survey up to £500.</strong> These are valid for 3 months.
      </Typography>
      <Typography gutterBottom>
        To check our pricing, click <a href="https://cheeseproject.co.uk/pricing/" target="_blank">HERE</a>
      </Typography>
      <Typography gutterBottom>
        Vouchers can be obtained from <a href="https://www.retrofitwestadvice.co.uk" target="_blank">www.retrofitwestadvice.co.uk</a> or you can ring them to discuss your requirements. The voucher will be emailed to you with a confirmation email and the voucher. <strong>Please obtain your voucher before contacting our office as we will need the details before confirming a booking.</strong>
      </Typography>
      <Typography gutterBottom>
        Once you have your voucher, send the confirmation email and your voucher to surveys@cheeseproject.co.uk and one of the team will call you to book you in.
      </Typography>
    </Box>
  )
}

export default OffSeasonMessage